import { useState } from 'react'
import { DownloadPerformanceReportRequest } from '@/api/fuelRegistries/request.types.ts'
import { useFuelRegistriesApiClient } from '@/api/fuelRegistries/useFuelRegistriesApiClient.ts'
import { useDownloadExcelFile } from '@/presentation/common/hooks/crud/v2/useDownloadExcelFile.ts'

export const useDownloadReport = () => {
  const repository = useFuelRegistriesApiClient()
  const query = useDownloadExcelFile<DownloadPerformanceReportRequest>({
    filename : 'performance.xlsx',
    callable : repository.downloadPerformanceResume,
    messages : {
      default : 'No se pudo descargar el archivo',
      loading : 'Obteniendo archivo',
      success : 'Archivo descargado',
    },
  })

  const [ data, setData ] = useState<File>()

  const submit = async (req: DownloadPerformanceReportRequest) => {
    const response = await query.submit(req)
    setData(response)
  }

  return {
    ...query,
    submit,
    data,
  }
}
